import { ParticipantRole } from "@azure/communication-calling"
import { addUserToRoom, fetchTokenData, getAzureSignedUrl, getUserToken, getDoctorUserToken, getPatientUserToken } from "../../../Common/axios_instance/axios_instance"


export const fetchTokenDataFun = async () => {
    try {
        let response = await fetchTokenData()
        console.log(response)
        return response.data
    } catch (error: any) {
        console.log(error)
        alert(error.response?.data?.message || "Some issue while getting token data")
    }

}

export const getUserTokenFun = async (): Promise<any> => {
    try {
        const response = await getUserToken({ scope: "chat,voip" }, "azure")
        return response.data
    } catch (error: any) {
        console.log(error)
        alert('Invalid token response');
    }
};

export const getDoctorUserTokenFun = async (consultationId: string): Promise<any> => {
    try {
        const response = await getDoctorUserToken("chat,voip", "azure", consultationId)
        return response.data
    } catch (error: any) {
        console.log(error)
        throw error;
    }
};

export const getPatientUserTokenFun = async (consultationId: string, roomId?: string): Promise<any> => {
    try {
        const response = await getPatientUserToken("chat,voip", "azure", consultationId, roomId)
        return response.data
    } catch (error: any) {
        console.log(error)
        throw error;
    }
};


export const addUserToRoomFun = async (userId: string, roomId: string, role: ParticipantRole): Promise<any> => {
    try {
        await addUserToRoom({ userId: userId, roomId: roomId, role: role })
        return false;
    } catch (error: any) {
        console.log(error)
        alert(error?.response?.data?.message || "Unable to add user to the room");
        return true;
    }
};

export const uploadPrescriptionFun = async (url: string, docName: string, benId: string, docType: string) => {
    try {
        const response = await getAzureSignedUrl(url, docName, benId, docType)
        return response.data
    } catch (error) {
        alert(error)
    }
}